import { ActionIcon, Paper } from "@mantine/core";
import { useTranslation } from "react-i18next";

import FormFieldSearch, { type FormFieldSearchProps } from "@/components/Form/FormFieldSearch";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import Icon from "@/utils/icons";

import type { DialogTriggerProps } from "@/components/Dialog/DialogBase";

export interface SearchDialogTriggerFieldProps extends DialogTriggerProps, Omit<FormFieldSearchProps, "onChange"> {}
export const SearchDialogTriggerField = ({ open, close, toggle, opened, ...props }: SearchDialogTriggerFieldProps) => {
  const { t } = useTranslation();
  return (
    <FormFieldSearch
      readOnly
      radius="xl"
      size="lg"
      leftSection={<Icon.SEARCH />}
      placeholder={t("search-in-knowledge-base")}
      onClick={open}
      onChange={() => {}}
      {...props}
    />
  );
};

export interface SearchDialogTriggerIconProps extends DialogTriggerProps {}
export const SearchDialogTriggerIcon = ({ open }: SearchDialogTriggerIconProps) => {
  return (
    <Paper shadow="xl" radius="xl">
      <ActionIcon variant="filled" color={SYSTEM_COLORS.primary} radius="xl" size={54} onClick={open}>
        <Icon.SEARCH size={28} />
      </ActionIcon>
    </Paper>
  );
};
